export const START_CALL_PHONE = "START_CALL_PHONE"
export const END_CALL = "END_CALL"